import { SeeqNames } from 'generated-seeqnames/app.constants.seeqnames';

export const WORKBOOK_VERSIONED_ITEM_TYPES = [SeeqNames.Types.Analysis, SeeqNames.Types.Topic];
